export const SUGAR_CRM_FIELDS = Object.freeze([
    '24h',
    'account_name',
    'address_supplement_c',
    'adgroup_id_c',
    'analytic_url_c',
    'answer',
    'assigned_user_id',
    'audience_id_c',
    'beamer',
    'birthdate',
    'book_from',
    'book_till',
    'business_c',
    'call_forward_number_c',
    'campaign_id',
    'captcha_solution',
    'catering',
    'chat_transcript_c',
    'company_sign',
    'conference_room',
    'confirm_authorization_c',
    'consentdataprocess_c',
    'conversion_details_c',
    'correlation_id',
    'country_c',
    'customer_comments_c',
    'customer_conditions_c',
    'debit_account_owner',
    'debit_account_id',
    'debit_bank_id',
    'directive_c',
    'domain',
    'email',
    'email1',
    'excuse_c',
    'expected_call_volume_c',
    'external_conversion_code_c',
    'fax_number_c',
    'fax',
    'fingerprint_c',
    'first_name',
    'form_id',
    'form_name_c',
    'free_trial_type_c',
    'full_name',
    'greeting_c',
    'init_way_of_contact_c',
    'initially_created_by_c',
    'interested_in_c',
    'last_name',
    'lead_belongs_to_c',
    'lead_category_c',
    'lead_type_c',
    'legal_form_c',
    'legal_representative_c',
    'location',
    'mail_forwarding',
    'mandantor_c',
    'mktcampaign_id_c',
    'mobile_number_c',
    'origin_campaign_c',
    'origin_details_c',
    'origin_medium_c',
    'origin_source_c',
    'page_type_c',
    'page_url_c',
    'page_version_c',
    'password',
    'phone_number_c',
    'position_c',
    'primary_address_city',
    'primary_address_postalcode',
    'primary_address_street',
    'product_c',
    'questions_c',
    'referral_code_c',
    'rating_c',
    'rav_id_c',
    'reception',
    'salutation',
    'sepa_account_owner',
    'sepa_iban',
    'sepa_bic',
    'short_time_office',
    'spam_probability_c',
    'status',
    'submit_id_c',
    'sugar_lead_id',
    'tariff_c',
    'team_id',
    'title',
    'tracking_order_id_c',
    'verification_hash',
    'verification_key',
    'visit_id_c',
    'visit_id',
    'visitor_id_c',
    'visitor_id',
    'vtuid_c',
    'voucher_code_c',
    'website',
    'where_from_c',
]);
export const RESERVED_FORM_NAMES = Object.freeze(['consent', 'direct_debit']);
